const productRoutes = [
  {
    path: '/product/index',
    name: 'ProductIndex',
    // 路由级别的代码分割
    // 这会为这个路由生成一个单独的块 (about.[hash].js)
    component: () => import(/* webpackChunkName: "product-index" */ '../views/product/index.vue')
  },
  {
    path: '/product/detail',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "product-detail" */ '../views/product/detail.vue')
  }
]

export default productRoutes
